module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/DrainTheOceans_NetEffects.925ce89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/DrainTheOceans_NetEffects.jpg
// module id = i5au
// module chunks = 0